module.exports = __webpack_public_path__ + "static/media/Photo10.7e6c571b.jpg";